export enum KnmAddressTypeCodesEnum {
  TYPE_I = 'TYPE_I',
  TYPE_II = 'TYPE_II',
  TYPE_III = 'TYPE_III',
  TYPE_OTHER = 'TYPE_OTHER',
}
